// extracted by mini-css-extract-plugin
module.exports = {"primaryColour":"#09CCC4","midGreyColour":"#868686","greyColour":"#C5C5C5","container":"IconsWheel_container__3x4fh"};